import React, { useState } from 'react';

const BaseInput = ({ 
  label, 
  name, 
  value, 
  onChange, 
  placeholder, 
  type = "text",
  required = false,
  disabled = false,
  error = null,
  description = null,
  className = "",
  icon = null,
  maxLength = null,
  minLength = null,
  autoComplete = null,
  autoFocus = false,
  readOnly = false,
  ...props 
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = value && value !== '';
  const inputId = `input-${name?.replace(/\s+/g, '-').toLowerCase()}`;
  const errorId = `${inputId}-error`;
  const descriptionId = `${inputId}-description`;

  return (
    <div className={`flex flex-col space-y-1 ${className}`}>
      {label && (
        <label 
          htmlFor={inputId}
          className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1" aria-label="campo obrigatório">*</span>}
        </label>
      )}
      
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 pointer-events-none">
            {icon}
          </div>
        )}
        
        <input
          id={inputId}
          name={name}
          type={type}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          minLength={minLength}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          readOnly={readOnly}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={`
            w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg 
            text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 
            focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:border-vox-green-500 
            transition-all duration-200
            ${icon ? 'pl-10' : ''}
            ${disabled ? 'opacity-60 cursor-not-allowed' : ''}
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''}
          `}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={`${descriptionId} ${errorId}`}
          {...props}
        />
      </div>
      
      {error && (
        <div 
          className="flex items-center gap-2 text-sm text-red-600 dark:text-red-400" 
          id={errorId}
          role="alert"
          aria-live="polite"
        >
          <span>⚠</span>
          {error}
        </div>
      )}
      
      {description && (
        <div 
          className="text-xs text-gray-500 dark:text-gray-400" 
          id={descriptionId}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export default BaseInput; 